import { render, staticRenderFns } from "./FeaturedFilter.vue?vue&type=template&id=9d186e38&lang=pug&"
import script from "./FeaturedFilter.vue?vue&type=script&lang=js&"
export * from "./FeaturedFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports